import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';
import FormCadastrarEditarForecast from 'components/forms/FormCadastrarEditarForecast';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import moment from 'moment';
import { useContext, useEffect, useMemo } from 'react';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export default function CadastrarForecast() {
	const { setters } = useContext(SidebarHelpContext);
	const { setDataSidebar } = setters;

	const helpCadastrarForecast = useMemo(
		(): ISidebarHelp => ({
			title: 'Cadastrar Forecast',
			firstParagraph: `Para cadastrar um novo forecast, selecione a Competência desejada e entre com os dados do Canal de Venda e Cliente.`,
			secondParagraph: `Para cadastrar um forecast, cadastre os canais de venda previamente em Cadastros > Comercial > Hierarquia.`,
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);

	useEffect(() => {
		setDataSidebar(helpCadastrarForecast);
	}, [helpCadastrarForecast, setDataSidebar]);

	const formInitialState = {
		data: moment().format('YYYY-MM-DD'),
		cliente_id: null,
		canal_venda_id: null,
		receita_bruta: null,
	};

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Card px='0px'>
				<FormCadastrarEditarForecast initialState={formInitialState} />
			</Card>
		</Flex>
	);
}
